import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { useInsiderState } from "@faire/retailer-visitor-shared/hooks/insider/useInsiderState";
import { getSettingInsiderSpecialGrandfatheringEligible } from "@faire/retailer-visitor-shared/settings/getSettingInsiderSpecialGrandfatheringEligible";
import { Button } from "@faire/web--source/slate/Button";
import { Column, Flex } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Span, Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackInsiderLoggedOutMarketingPageExclusiveBenefitsView } from "@faire/web-api--source/events/insider/view/loggedOutMarketingPageExclusiveBenefits";
import supportArticle from "@faire/web-api--source/routes/support/articles/articleId";
import React from "react";
import styled from "styled-components";
export var InsiderBenefitsOverview = function(param) {
    var title = param.title, children = param.children;
    var ref = useDoActionWhenVisible(function() {
        trackInsiderLoggedOutMarketingPageExclusiveBenefitsView();
    });
    return /*#__PURE__*/ _jsx(OuterWrapper, {
        ref: ref,
        children: /*#__PURE__*/ _jsxs(Wrapper, {
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    variant: {
                        mobileAndAbove: "displaySSerifRegular",
                        desktopAndAbove: "displayMSerifRegular"
                    },
                    children: title
                }),
                /*#__PURE__*/ _jsx(ContentWrapper, {
                    children: children
                }),
                /*#__PURE__*/ _jsx(Disclaimer, {})
            ]
        })
    });
};
var Disclaimer = function() {
    var isInsiderCancelled = useInsiderState().isInsiderCancelled;
    return getSettingInsiderSpecialGrandfatheringEligible() && !isInsiderCancelled ? /*#__PURE__*/ _jsxs(DisclaimerWrapper, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "D8CXvx",
                    defaultMessage: [
                        {
                            type: 8,
                            value: "TextFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "Limited time offer!"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: " For any European brands you've already ordered on Faire, you'll get free shipping and duties through the end of the year."
                        }
                    ],
                    values: {
                        TextFormatting: DisclaimerHighlightTextFormatting
                    }
                })
            }),
            /*#__PURE__*/ _jsx(StyledButton, {
                linkTo: supportArticle("13886479318299"),
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "9ZesPN",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Learn more"
                        }
                    ]
                })
            })
        ]
    }) : null;
};
var DisclaimerHighlightTextFormatting = function(chunks) {
    return /*#__PURE__*/ _jsx(Span, {
        color: Decorative.icon.teal,
        variant: "paragraphSansMedium",
        children: chunks
    });
};
var OuterWrapper = styled.div.withConfig({
    componentId: "sc-e5f39595-0"
})([
    "position:relative;width:100%;overflow:hidden;background-color:",
    ";"
], Core.surface.inverse);
var Wrapper = styled(Column).attrs({
    gap: 34,
    align: "center"
}).withConfig({
    componentId: "sc-e5f39595-1"
})([
    "width:100%;margin:auto;padding:",
    ";",
    "{padding:",
    ";}",
    "{padding:",
    ";}max-width:1024px;",
    "{max-width:1104px;}"
], getSpacing("5x", "4x"), responsiveMediaQueries.tabletAndAbove, getSpacing("10x", "7x"), responsiveMediaQueries.desktopAndAbove, getSpacing("10x", "5x"), responsiveMediaQueries.xLargeAndAbove);
var ContentWrapper = styled(Flex).attrs({
    gap: {
        mobileAndAbove: 40,
        desktopAndAbove: 60
    },
    direction: {
        mobileAndAbove: "column",
        tabletAndAbove: "row"
    }
}).withConfig({
    componentId: "sc-e5f39595-2"
})([
    ""
]);
var DisclaimerWrapper = styled(Column).attrs({
    justify: "center",
    align: "flex-start"
}).withConfig({
    componentId: "sc-e5f39595-3"
})([
    "width:100%;background-color:",
    ";padding:",
    ";"
], Core.surface.inverse, getSpacing("3x"));
var StyledButton = styled(Button).attrs({
    variant: "tertiary",
    target: "_blank"
}).withConfig({
    componentId: "sc-e5f39595-4"
})([
    "flex:none;"
]);
